import classNames from 'classnames';
import { Trans, useTranslation } from 'next-i18next';

import { CheckmarkIcon } from '@catawiki/cata-style';

import styles from './Experts.module.scss';
import { ExpertsGallery } from './components/ExpertsGallery';
import { StrongBrandContainer } from '../../components/StrongBrandContainer';

export const Experts = () => {
  const { t } = useTranslation();

  const blockContent = [
    {
      title: t('seller_register.experts.review_title'),
      subtitle: t('seller_register.experts.review_subtitle'),
    },
    {
      title: t('seller_register.experts.assist_title'),
      subtitle: t('seller_register.experts.assist_subtitle'),
    },
    {
      title: t('seller_register.experts.select_title'),
      subtitle: t('seller_register.experts.select_subtitle'),
    },
  ];

  return (
    <section className="u-m-t-xxl-18">
      <h2 className="u-typography-h2 u-p-r-xl">
        <Trans
          i18nKey="seller_register.experts.title"
          components={{
            strong: <StrongBrandContainer className="u-typography-h2-serif" />,
          }}
        />
      </h2>

      <h3 className="u-typography-h3 u-m-t-xxl-10">
        {t('seller_register.experts.subtitle')}
      </h3>
      <div
        className={classNames(
          styles.list,
          'tw:flex tw:justify-between u-m-t-xl u-g-xxl-6'
        )}
      >
        {blockContent.map((block) => (
          <div
            key={block.title}
            className={classNames(
              styles.item,
              'tw:flex-1 u-p-t-xxl-4 u-m-b-sm-l tw:relative'
            )}
          >
            <h5 className="u-typography-h5">{block.title}</h5>
            <h6 className="u-typography-h6 u-m-t-m u-color-secondary">
              {block.subtitle}
            </h6>
            <CheckmarkIcon className={styles.checkmarkIcon} />
          </div>
        ))}
      </div>

      <h3 className="u-typography-h3 u-m-t-xxl-10 u-m-b-l">
        {t('seller_register.experts.slider_title')}
      </h3>
      <ExpertsGallery />
    </section>
  );
};
